import Concentrix from "../assets/concentrix_logo.jpg";
import Pluger from "../assets/pluger-icon.webp";
import Morago from "../assets/morago-icon.jpg";
import URConnection from "../assets/urconnection_logo.jpg";

const experiece = [
  {
    id: 1,
    period: "08.2025 - Present",
    title: "Backend Engineer (remote)",
    company: "Morago",
    image: Morago,
    stack: [
      "Java",
      "Spring Boot",
      "MySQL",
      "RESTful APIs",
      "JWT",
      "Spring Security",
      "GitHub",
      "Docker",
      "Redis",
      "Flyway",
      "AWS",
    ],
    duties: [
      "Built and maintained a Spring Boot backend powering an on-demand interpretation platform, supporting real user traffic and production use cases.",
      "Implemented secure authentication and role-based authorization with Spring Security and JWT, balancing security requirements with developer usability.",
      "Designed and optimized RESTful APIs and MySQL schemas to ensure data consistency, performance, and long-term maintainability.",
      "Worked closely with frontend, QA, and product teams to translate business requirements into reliable backend features, iterating quickly based on feedback",
    ],
  },
  {
    id: 5,
    period: "04.2025 - 08.2025",
    title: "Software Developer (full-time)",
    company: "Pluger (marketbilli.com)",
    image: Pluger,
    stack: [
      "Vue",
      "NodeJs",
      "Java",
      "Spring Boot",
      "Docker",
      "MySQL",
      "Magneto",
      "WebSocket",
      "GitLab",
    ],
    duties: [
      "Developed responsive web applications using Vue 3 and Nuxt for hybrid (web, mobile) application, optimizing performance and cross-browser compatibility across various devices.",
      "Collaborated with designers and backend developers to deliver features on schedule and improved team efficiency by refining development workflows.",
      "Strengthened code quality and maintainability through systematic debugging and performance optimization.",
    ],
  },
  {
    id: 2,
    period: "07.2025 - 08.2025",
    title: "Front-End Shopify Theme Developer (Collaboration)",
    company: "Concentrix",
    image: Concentrix,
    stack: ["HTML", "CSS", "JavaScript", "Shopify", "Liquid", "GitHub"],
    duties: [
      "Customized Shopify themes using Liquid, HTML, CSS, and JavaScript to meet client requirements and enhance user experience.",
      "Collaborated with designers and backend developers to implement responsive designs and ensure cross-browser compatibility.",
      "Optimized website performance through code refinement and efficient asset management.",
    ],
  },
  {
    id: 3,
    period: "09.2024 - 04.2025",
    title: "Front-end developer (remote)",
    company: "URConnection",
    image: URConnection,
    stack: [
      "ReactJs",
      "React Native",
      "Styled-Components",
      "Hooks",
      "Redux",
      "Figma",
      "MongoDB Atlas",
      "NodeJs",
      "ExpressJs",
      "RESTful APIs",
    ],
    duties: [
      "Developed and maintained responsive web and mobile applications using ReactJs and React Native, ensuring cross-platform compatibility and optimal performance.",
      "Collaborated with designers to translate Figma designs into pixel-perfect user interfaces, enhancing user experience and engagement.",
      "Implemented state management using Redux to streamline data flow and improve application scalability.",
      "Worked closely with backend developers to integrate RESTful APIs, ensuring seamless data exchange between frontend and backend systems.",
    ],
  },
];

export default experiece;
